import { User } from './User';

export type LinkMetadata = {
  hasMinimalAndroidVersionForVideoCall: boolean;
  hasMinimalArdoizCoreVersionForVideoCall: boolean;
  subscriptionEnabled: boolean;
};

export type Link = {
  channelKey: string;
  isAdmin: boolean;
  metadata: LinkMetadata;
  type: LinkType;
  mainUser?: User;
  selfWebUserId: string;
  userKey: string;
};

export enum LinkType {
  CONTACT = 'Contact',
  SELF = 'Self',
}